import * as React from "react";
import { DayPicker } from "react-day-picker";
import { cn } from "../../lib/utils";
import { buttonVariants } from "./Button";

type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        months: "relative flex",
        month: "w-full",
        month_caption: "relative mx-10 flex h-7 items-center justify-center",
        caption_label: "truncate text-sm font-medium dark:text-white",
        nav: "flex items-start",
        button_previous: cn(
          buttonVariants({
            variant: "outline",
            className:
              "absolute h-7 w-7 bg-white dark:bg-grey-800 [&_svg]:dark:fill-white p-0 opacity-50 hover:opacity-100 hover:bg-grey-50 dark:hover:bg-grey-700 left-0",
          }),
        ),
        button_next: cn(
          buttonVariants({
            variant: "outline",
            className:
              "absolute h-7 w-7 bg-white dark:bg-grey-800 [&_svg]:dark:fill-white p-0 opacity-50 hover:opacity-100 hover:bg-grey-50 dark:hover:bg-grey-700 right-0",
          }),
        ),
        day: "flex size-8 flex-1 items-center justify-center p-0 text-sm",
        day_button: cn(
          buttonVariants({
            variant: "ghost",
            className:
              "hover:bg-primary-500 size-8 hover:text-white p-0 font-normal transition-none aria-selected:opacity-100",
          }),
        ),
        range_start:
          "[&>button]:bg-primary-600 [&>button]:text-white day-range-start [&>button]:rounded-l-lg [&>button]:rounded-none",
        range_end:
          "[&>button]:bg-primary-600 [&>button]:text-white day-range-end [&>button]:rounded-r-lg [&>button]:rounded-none",
        selected: "[&>button]:bg-primary-600 [&>button]:!text-white",
        range_middle: "[&>button]:!bg-primary-500 [&>button]:rounded-none",
        outside: "day-outside opacity-75",
        hidden: "invisible flex-1",
        today: "[&>button]:text-primary-500",
        disabled: "opacity-50",
        weekdays: "flex flex-row",
        weekday: "w-8 text-sm font-normal text-grey-300",
        month_grid: "mx-2 mt-4",
        week: "mt-2 flex w-max items-start",
        ...classNames,
      }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
